import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Wrapper } from "@cinch-nx/shared-ui";
import { formatBreadcrumbListSchema } from "../json-ld-script";
import { JsonLdScript } from "../json-ld-script";
import styles from "./breadcrumbs.module.css";
export const Breadcrumbs = ({ breadcrumbs  })=>{
    const linkableCrumbs = breadcrumbs.filter((el, idx)=>idx !== breadcrumbs.length - 1);
    const lastCrumb = breadcrumbs[breadcrumbs.length - 1];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(JsonLdScript, {
                schema: formatBreadcrumbListSchema(breadcrumbs)
            }),
            /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                className: {
                    inner: styles.wrapper
                },
                children: /*#__PURE__*/ _jsxs("ul", {
                    className: styles.list,
                    "data-testid": "bread-crumbs",
                    children: [
                        linkableCrumbs.map((crumb)=>/*#__PURE__*/ _jsx("li", {
                                className: styles.listItem,
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: crumb.url,
                                    children: crumb.text
                                })
                            }, crumb.text)),
                        /*#__PURE__*/ _jsx("li", {
                            className: styles.listItem,
                            children: /*#__PURE__*/ _jsx("span", {
                                children: lastCrumb.text
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export default Breadcrumbs;
